import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import DoctorReview from '../pages/review';
import View from '../pages/review/view';

export function DoctorReviews() {
  return (
    <Routes>
        <Route path='/' element={<Index child={<DoctorReview />}/>} />
        <Route path='/medical-record' element={<Index child={<View />}/>} />
    </Routes>
  );
}
